import s from './home.module.css';
import { useModal } from '@/lib/ModalContext';

export default function CTABanner() {
  const { setOpen } = useModal();
  return (
    <section>
      <div className="container">
        <div className={s.cta}>
          <h2 className={s.ctaTitle}>Your practice, on its own engine.</h2>
          <p className={s.ctaSub}>
            Private beta opens this summer. We are onboarding a small founding cohort of independent,
            bar-admitted attorneys — request a walkthrough and see the platform under your firm&rsquo;s brand.
          </p>
          <div className={s.ctaRow}>
            <button className={`${s.btn} ${s.btnPrimary}`} onClick={() => setOpen('waitlist')}>Request a walkthrough (attorneys)</button>
            <button className={`${s.btn} ${s.btnSecondary}`} onClick={() => setOpen('intake')}>Preview the client experience</button>
          </div>
        </div>
      </div>
    </section>
  );
}
